import clg from "./log";

function Validator( config ) {
    this.minLength = 3;

    const self = this;

    this.validate = function( validationObj ) {
        const value = validationObj.value;

        this.default = function(debug) {
            //Ha nincs megadva validációs típus, akkor alapértelmezett hosszra van validálva. Ha van megadva külön minLength, akkor az alapján, különben self.minLength alapján
            let minLength = null;
            if( validationObj.hasOwnProperty("conditions") ) {
                if( validationObj.conditions.hasOwnProperty("minLength") ) {
                    minLength = validationObj.conditions.minLength;
                }
            }

            if( minLength ) return self.validateMinLength( value, minLength );
            else return self.validateMinLength(value);
        }

        if( validationObj.hasOwnProperty("conditions") ){
            if( validationObj.conditions.hasOwnProperty("validationType") ) {
                
                switch ( validationObj.conditions.validationType ) {
                    case "email":
                        return self.validateEmail( value );

                    case "phone":
                        return self.validatePhoneNumber( value );

                    default:
                        return this.default(1);  
                }

            } else return this.default(2);
        } else return this.default(3);
    }

    this.validateEmail = function(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    this.validatePhoneNumber = function(phoneNumber) {
        const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        return re.test(phoneNumber);
    }

    this.validateMinLength = function(value, minLength = self.minLength) {
        if( value.length >= minLength ) return true;
        else return false;
    }

    this.getFullValidity = function( obj ) {
        /*
        * pl: azokból a mezőkből képez egy végső döntést, amikben szerepel validation mező.
        {
            "property_id": [],
            "first_name": {
                "value": "aaa",
                "validation": true
            },
            "last_name": {
                "value": "aaa",
                "validation": true
            },
        }
        */
        let validationObj = {
            details : {},
            decision : false,
        };

        let decisionArr = [];

        Object.keys(obj).map(function(key,value){
            const curr = obj[key];

            if( curr.hasOwnProperty("validation") ) {
                validationObj.details[key] = curr.validation;
                decisionArr.push(curr.validation);
            }
        });

        validationObj.decision = !decisionArr.includes(false);

        return validationObj;
    }

    this.removeValidationFields = function( form ) {

        let modifiedForm = {...form};

        Object.keys(form).map(function(key,value){
            const curr = form[key];
            
            if( curr.hasOwnProperty("validation") ) {
                const currValue = ( curr.value ? curr.value : null );

                modifiedForm[key] = currValue;
            }
        });

        return modifiedForm;
    }
}

export default new Validator;